import React, {useEffect, useState} from 'react';
import './MainContent.css';
import interactiveMapImage from "./intmapimagetest.png";
import {FaMapMarkerAlt} from "react-icons/fa";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {Tooltip} from "@mui/material";

const BoxContent = ({imgSrc, title, description, descriptionForTooltip, linkText, to, isLeftBox}) => {
    const isRightBox = !isLeftBox;

    const content = (
        <div>
        <div  className="container-maincontent">
            {isLeftBox && <FaMapMarkerAlt className="map-icon"/>}
            <Tooltip
                title={descriptionForTooltip}
                placement="bottom-start"
                PopperProps={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [440, 215],
                            },
                        },
                    ],
                }}
            >
                {imgSrc !== null && (
                    <span >
                    <img className="maincontent-image" src={imgSrc} alt="Box"/>
                </span>
                )}

            </Tooltip>

            {isLeftBox && <p className="map-title-homepage">{title}</p>}
            {isRightBox && <p className="mainContent-title">{title}</p>}
            {isLeftBox && <p className="map-description">{description}</p>}
            {isRightBox && (
                <>
                    <p style={{maxWidth: 400}} className="mainContent-description">{description}</p>

                    <button
                        className="homepage-news-button"
                    >
                        {linkText}
                    </button>

                </>

            )}
        </div>
        </div>
    );

    return isLeftBox ? (
        <Link to={to} className="mainContent-link-wrapper"
              style={{color: 'inherit', textDecoration: 'none'}}>{content}</Link>

    ) : (
        content
    );
};

const MainContent = ({newsData}) => {
    const {t, i18n} = useTranslation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const navigate = useNavigate();


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    };

    const getContent = (item, isGeo) => {
        return {
            imgSrc: item.path,
            title: truncateText(isGeo ? item.title : item.titleEng, 45),
            description: truncateText(isGeo ? item.description : item.descriptionEng, 65),
            descriptionForTooltip: truncateText(isGeo ? item.description : item.descriptionEng, 90),
            linkText: isGeo && item.buttonText ? item.buttonText : !isGeo && item.buttonTextEng ? item.buttonTextEng : isGeo ? 'გაიგე მეტი' : 'Learn More',
            to: `/new/${item.id}`,
        };
    };

    const lastTwoNews = newsData.slice(-2);
    const rightContent1 = lastTwoNews.length > 0 ? getContent(lastTwoNews[0], i18n.language === 'geo') : {};
    const rightContent2 = lastTwoNews.length > 1 ? getContent(lastTwoNews[1], i18n.language === 'geo') : {};

    const leftContent = {
        imgSrc: interactiveMapImage,
        title: t("ინტერაქტიული რუკა"),
        description: (
            <>
                {t("რუკის საშუალებით თქვენ შეგიძლიათ გაიგოთ ნებისმიერი ობიექტის კოორდინატები,")}<br/>
                {t("ნახოთ სასურველი ტერიტორიის ფართობი ან გაზომოთ მანძილი სხვადასხვა ობიექტს შორის.")}
            </>
        ),
        linkText: t("რუკის ნახვა"),
        to: "/interactivemap",
        isLeftBox: true
    };

    return (
        <div>
            <div className="main-container">
                <div className="mainContent">
                    <div onClick={() => navigate(leftContent.to)} className="leftBox">
                        <BoxContent {...leftContent} />
                    </div>
                    <div  className="rightBoxContainer">
                        {rightContent2 && isMobile && (
                            <div onClick={() => navigate(rightContent2.to)} className="leftBox">
                                <BoxContent {...rightContent2} />
                            </div>
                        )}
                        {rightContent2 && !isMobile && (
                            <div onClick={() => navigate(rightContent2.to)} className="rightBox">
                                <BoxContent {...rightContent2} />
                            </div>
                        )}

                        {rightContent1 && !isMobile && (
                            <div onClick={() => navigate(rightContent1.to)} className="rightBox">
                                <BoxContent {...rightContent1} />
                            </div>
                        )}
                        {rightContent1 && isMobile && (
                            <div onClick={() => navigate(rightContent1.to)} className="leftBox">
                                <BoxContent {...rightContent1} />
                            </div>
                        )}
                    </div>
                </div>
            </div>


        </div>


    );
};

export default MainContent;
